import React from 'react'


import star from './../../../UI/canvasMobile/topMenu/star.svg'

interface Props {
  showSurvey: boolean,
  handleShowSurvey: any
}

interface State {
  currentModalIndex: number,
  experienceCount: number,
  findCount: boolean,
  friendCount: number,
  comentary: string
}

declare const window: any;

class SurveyModalMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentModalIndex: 0,
      experienceCount: 0,
      findCount: false,
      friendCount: 0,
      comentary: ''
    }
  }

  handleExperienceCount = (payload: number) => {
    this.setState({
      experienceCount: payload,
      currentModalIndex: this.state.currentModalIndex + 1
    }, () => {
  
      
      window.paramsObj = {
          "section-qualification": `${window.id_sesion}>1>${payload}`,
      }

      window.ym(88905571, "params", window.paramsObj || {});
})
  }

  handleFindCount = (payload: boolean) => {
    this.setState({
      findCount: payload,
      currentModalIndex: this.state.currentModalIndex + 1
    }, () => {
      window.paramsObj = {
          "section-qualification": `${window.id_sesion}>2>${payload}`,
      }

      window.ym(88905571, "params", window.paramsObj || {});
})
  } 

  handleFriendCount = (payload: number) => {
    this.setState({
      friendCount: payload,
      currentModalIndex: this.state.currentModalIndex + 1
    }, () => {
      window.paramsObj = {
          "section-qualification": `${window.id_sesion}>3>${payload}`,
      }

      window.ym(88905571, "params", window.paramsObj || {});
})
  } 

  handleCommentary = () => {
    this.setState({
      currentModalIndex: this.state.currentModalIndex + 1
    }, () => {
      window.paramsObj = {
        "section-qualification": `${window.id_sesion}>3>${this.state.comentary}`,
    }

      window.ym(88905571, "params", window.paramsObj || {});
    })
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.showSurvey ? 'survey-container-mobile fade-in':'survey-container-mobile fade-out'}>
            <div className={this.props.showSurvey ? 'survey-modal-container-mobile fade-in':'survey-modal-container-mobile fade-out'}>
            {
              this.state.currentModalIndex === 0 ?
              <div className='survey-modal-start'>
                <div className='survey-box'>
                  <img src={star} alt='' className='survey-box-star'/>
                  <div className='survey-box-text'>¡Califícanos!</div> 
                </div>
                <div className='survey-container'>
                  <div className='survey-text'>Cuéntanos tu nivel de satisfacción con nuestro Showroom.</div>
                  <div className='survey-box-btns-container'>
                    <div className='later-btn-container' onClick={() => {this.props.handleShowSurvey()}}>
                      Después
                    </div>
                    <div className='start-btns-container' onClick={() => {
                      this.setState({
                        currentModalIndex: this.state.currentModalIndex + 1
                      })
                    }}>
                      ¡Comencemos!
                    </div>
                  </div>
                </div>
              </div>:null
            }
            {
              this.state.currentModalIndex === 1 ?
              <div className='survey-modal-start'>
                <div className='survey-box'>
                  <img src={star} alt='' className='survey-box-star'/>
                  <div className='survey-box-text'>¡Califícanos!</div> 
                </div>
                <div className='survey-container'>
                  <div className='survey-text'>¿Cómo está tu experiencia en el Showroom?</div>
                  <div className='radio-btns-container'>
                              <div className={this.state.experienceCount === 1 ? 'radio-btn selected-radio':'radio-btn'} id='element-umbra-analytics' data-value={"1"} data-second={"1"}  data-type={"ENCUESTA"} onClick={() => {this.handleExperienceCount(1)}}>1</div>
                              <div className={this.state.experienceCount === 2 ? 'radio-btn selected-radio':'radio-btn'} id='element-umbra-analytics' data-value={"1"} data-second={"2"}  data-type={"ENCUESTA"} onClick={() => {this.handleExperienceCount(2)}}>2</div>
                              <div className={this.state.experienceCount === 3 ? 'radio-btn selected-radio':'radio-btn'} id='element-umbra-analytics' data-value={"1"} data-second={"3"}  data-type={"ENCUESTA"} onClick={() => {this.handleExperienceCount(3)}}>3</div>
                              <div className={this.state.experienceCount === 4 ? 'radio-btn selected-radio':'radio-btn'} id='element-umbra-analytics' data-value={"1"} data-second={"4"}  data-type={"ENCUESTA"} onClick={() => {this.handleExperienceCount(4)}}>4</div>
                              <div className={this.state.experienceCount === 5 ? 'radio-btn selected-radio':'radio-btn'} id='element-umbra-analytics' data-value={"1"} data-second={"5"}  data-type={"ENCUESTA"} onClick={() => {this.handleExperienceCount(5)}}>5</div>
                          </div>
                          <div className='radio-btns-container-text'>
                              <div className={'radio-text'}>Muy mala</div>
                              <div className={'radio-text'}>Muy buena</div>
                          </div>
                </div>
              </div>:null
            }
            {
              this.state.currentModalIndex === 2 ?
              <div className='survey-modal-start'>
                <div className='survey-box'>
                  <img src={star} alt='' className='survey-box-star'/>
                  <div className='survey-box-text'>¡Califícanos!</div> 
                </div>
                <div className='survey-container'>
                  <div className='survey-text'>¿Hemos resuelto tu consulta y/o lo que buscabas?</div>
                  <div className='radio-btns-container'>
                              <div 
                              className={this.state.findCount === true ? 'radio-btn selected-radio':'radio-btn'} 
                              onClick={() => {this.handleFindCount(true)}}
                              style={{
                                width: "4rem",
                                borderRadius: "2rem"
                              }}
                              id='element-umbra-analytics' data-value={"2"} data-second={"5"}  data-type={"ENCUESTA"}
                              >Si</div>
                              <div 
                              className={this.state.findCount === false ? 'radio-btn selected-radio':'radio-btn'} 
                              onClick={() => {this.handleFindCount(false)}}
                              style={{
                                width: "4rem",
                                borderRadius: "2rem"
                              }}
                              id='element-umbra-analytics' data-value={"2"} data-second={"1"}  data-type={"ENCUESTA"}
                              >No</div>
                          </div>
                </div>
              </div>:null
            }
            {
              this.state.currentModalIndex === 3 ?
              <div className='survey-modal-start'>
                <div className='survey-box'>
                  <img src={star} alt='' className='survey-box-star'/>
                  <div className='survey-box-text'>¡Califícanos!</div> 
                </div>
                <div className='survey-container'>
                <div className='survey-text'>Déjanos un comentario</div>
                <div className='text-area-container'>
                  <textarea onChange={(e) => {this.setState({comentary: e.target.value})}} style={{resize: 'none'}} maxLength={160}/>
                </div>
                <div className='send-btn'  onClick={() => {this.handleCommentary()}}  id='element-umbra-analytics' data-value={"3"} data-second={this.state.comentary}  data-type={"ENCUESTA"}>
                  Enviar
                </div>
                </div>
              </div>:null
            }
            {
              this.state.currentModalIndex === 4 ?
              <div className='survey-modal-start'>
                <div className='survey-box'>
                  <img src={star} alt='' className='survey-box-star'/>
                  <div className='survey-box-text'>¡Califícanos!</div> 
                </div>
                <div className='survey-container'>
                  <div className='survey-text-end'>¡Gracias por ayudarnos a mejorar!</div>
                  <div className='survey-close-btn' onClick={() => {
                    this.props.handleShowSurvey()
                    this.setState({
                      currentModalIndex: 0,
                      experienceCount: 0,
                      findCount: false,
                      friendCount: 0
                    })
                    }}>
                    Cerrar
                  </div>
                </div>
              </div>:null
            }
          </div>
        </div>
      )
  }
}

export default SurveyModalMobile